import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M1 3.5A1.5 1.5 0 012.5 2H22a1.5 1.5 0 011.5 1.5V14a1.5 1.5 0 01-1.5 1.5H2.5A1.5 1.5 0 011 14V3.5zm21 0H2.5V14H22V3.5z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.25 6.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.5 8.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM16.186 2.256a.75.75 0 011.058-.07l6 5.25a.75.75 0 01-.988 1.128l-6-5.25a.75.75 0 01-.07-1.058z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M23.314 9.006a.75.75 0 01-.07 1.058l-6 5.25a.75.75 0 11-.988-1.128l6-5.25a.75.75 0 011.058.07zM8.314 2.256a.75.75 0 01-.07 1.058l-6 5.25a.75.75 0 11-.988-1.128l6-5.25a.75.75 0 011.058.07z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M1.186 9.006a.75.75 0 011.058-.07l6 5.25a.75.75 0 11-.988 1.128l-6-5.25a.75.75 0 01-.07-1.058zM12.25 13.75a.75.75 0 01.75.75v6.188a.75.75 0 01-1.5 0V14.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M9.188 17.626a.75.75 0 011.061 0l2.001 2 2-2a.75.75 0 011.062 1.06l-2.532 2.532a.75.75 0 01-1.06 0l-2.532-2.531a.75.75 0 010-1.061z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
